var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"appflowz-wrapper"}},_vm._l((_vm.surveys),function(survey){return _c('widget-main',{key:survey.id,attrs:{"survey_id":survey.id,"stepid":_vm.stepid},on:{"close-widget":_vm.closeWidget,"router-push":_vm.routerPush}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }